import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from './client';
import { qk } from './queryKeys';
import type { ConsentTextDto, MyPrivacyDto, RecordConsentRequest } from './types';

export const privacyApi = {
  texts: (lang: string) => api<ConsentTextDto[]>('/api/consents', { query: { lang }, auth: false }),
  mine: () => api<MyPrivacyDto>('/api/me/privacy'),
  record: (body: RecordConsentRequest) => api<MyPrivacyDto>('/api/me/consents', { method: 'POST', body }),
};

/** The notice and consent texts (public: shown before signing up). */
export function useConsentTexts(lang: string) {
  const short = lang.startsWith('en') ? 'en' : 'tr';
  return useQuery({ queryKey: ['consents', short], queryFn: () => privacyApi.texts(short), staleTime: 60 * 60_000 });
}

export function useMyPrivacy() {
  return useQuery({ queryKey: ['privacy', 'mine'], queryFn: privacyApi.mine });
}

/** Records an answer; the app's view of the signed-in person (pending notices, the device answer) follows. */
export function useRecordConsent() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: privacyApi.record,
    onSuccess: (data) => {
      qc.setQueryData(['privacy', 'mine'], data);
      void qc.invalidateQueries({ queryKey: qk.me });
    },
  });
}
